module.exports = __webpack_public_path__ + "img/cog-red.939ed177.svg";